module.exports = {
    columnType: {
        STATUS: 'status',
        PRIORITY: 'priority',
        ACTION_REQUIRED: 'actionRequired',
        ASSIGNED_TO: 'assignedTo',
        PROJECT: 'project',
        TAG: 'tag'
    },

    viewSize: {
        SMALL: 'small',
        MEDIUM: 'medium',
        LARGE: 'large'
    },

    viewColor: {
        NONE        : 'none',
        PROJECT     : 'project',
        STATUS      : 'status'
    },
};